export function getSeriesBy(series, accessor, match) {
    if (series === undefined)
        return undefined;
    var pairs = Object.entries(series)
        .filter(function (_a) {
        var series = _a[1];
        return accessor(series) === match;
    })
        .filter(function (_a) {
        var series = _a[1];
        return series !== undefined;
    });
    if (pairs.length === 0)
        return undefined;
    return Object.fromEntries(pairs);
}
//# sourceMappingURL=getSeriesBy.js.map